module.exports = __webpack_public_path__ + "static/media/tcs.4c06d201.jpg";